export const HUGE = 1440;
export const LARGE = 1170;
export const MEDIUM = 768;
export const SMALL = 450;
